<template>
  <div class="slide-selector">
    <div
      v-for="(item, index) in selection"
      :key="`slide-selector-item-${index}`"
      class="selector-item"
      :class="current === index ? 'is-active' : ''"
      @click="$emit('selected', index)"
    >
      <UserAvatar
        :image="item.image"
        :name="item.name"
        :title="item.title"
        class="user-avatar mb-4"
      />
      <TypeBody
        :options="$options.Typography.Body.TEXT"
        :weight="$options.Typography.Weights.MEDIUM"
        tag="p"
      >
        {{ item.body }}
      </TypeBody>
    </div>
  </div>
</template>

<script>
import { constants, TypeBody, UserAvatar } from '@bambeehr/pollen';

const { Typography } = constants;
export default {
  name: 'SlideSelector',
  Typography,
  components: {
    TypeBody,
    UserAvatar,
  },
  props: {
    current: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      selection: [
        {
          image: '/assets/images/market/beautiful-people/male-5.svg',
          name: 'Cameron Williamson',
          title: 'Casco Bay Dental',
          body: 'How can I avoid paying unemployment?',
        },
        {
          image: '/assets/images/market/beautiful-people/female-3.svg',
          name: 'Dianne Russell',
          title: 'Carpet Caretakers, LLC',
          body: 'Can I terminate someone with a disability?',
        },
        {
          image: '/assets/images/market/beautiful-people/female-4.svg',
          name: 'Eleanor Pena',
          title: 'Waba grill',
          body: 'What is the EEOC?',
        },
      ],
    };
  },
};
</script>

<style scoped>
.slide-selector {
  max-width: 340px;
  text-align: left;
}

.selector-item {
  background-color: transparent;
  cursor: pointer;
  padding: 18px;
}

.selector-item.is-active {
  background-color: #f9faf9;
}

.user-avatar {
  margin-bottom: 18px;
}
</style>
